import Text from "../../components/Text";
import Spinner from "../../components/Spinner";
import { Row, Col } from "../../components/Flexbox";
import FilterBar from "../../components/FilterBar";
import { DateFormatter } from "../../utils";
import { useTheme } from "../../scripts/functions/ThemeProvider";

import { MenuItem } from "@mui/material";
import Dropdown from "../../components/Dropdown";
import SearchBox from "../../components/SearchBox";
import { useProcess } from "../../containers/ProcessNormalizer";
import ProcessTable from "../../components/ProcessTable";

const Proceso = () => {
    const {theme} = useTheme();

    const {search, activeOption, secondOption, customers, resources, table, isFetching, loading, lastUpdate, fetchProcesses, setSearch, setActiveOption, setSecondOption, exportCSV} = useProcess();

    return (
        <Col style={{ width:'100%', flex:'none',alignItems:'flex-start', paddingLeft: 64, paddingRight:64, paddingTop:64}}>
            <Row style={{justifyContent:'space-between', width: '100%', maxHeight: '36px', gap: '32px', marginBottom: '16px', flexWrap: 'wrap'}} mobileStyle={{gap: 8}}>
                <Text size='21px' color={theme.Black}>Proceso</Text>
                <Col style={{alignItems:'end'}} mobileStyle={{alignItems: 'flex-start', width: '100%', gap: 8}}>
                    <FilterBar style={{width: '100%', justifyContent: 'flex-end'}}>
                        <Text color={theme.SEVENB} size={15} style={{whiteSpace: 'nowrap'}}>{lastUpdate ? DateFormatter(lastUpdate.toString(), "FULL_DATE") : '\u200E'}</Text>
                    </FilterBar>
                    <Text onClick={() => !isFetching && fetchProcesses()} style={{cursor:'pointer'}} color={theme.Magenta} size={15}>Actualizar</Text>
                </Col>
            </Row>
            <FilterBar style={{width: '100%', maxHeight: '64px', gap: '26px', alignItems: 'center', marginTop: '32px', justifyContent: 'space-between'}}>
                <Row style={{flex: 1, justifyContent: 'flex-start',maxHeight: '36px', gap: 16}}>
                    <Dropdown theme={theme} placeholder="Cliente(s)" multiple value={activeOption} onChange={(value) => setActiveOption(value)} style={{width: '342px', height: '36px'}}>
                        {customers.length > 0 && customers.map(customer => (
                            <MenuItem key={customer} value={customer}>{customer}</MenuItem>
                        ))}
                    </Dropdown>
                    <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} value = {search} onChange={setSearch}></SearchBox>
                    <Dropdown theme={theme} placeholder="Recurso" multiple value={secondOption} onChange={(value) => setSecondOption(value)} style={{width: '342px', height: '36px'}}>
                        {resources.length > 0 && resources.map(resource => (
                            <MenuItem key={resource} value={resource}>{resource}</MenuItem>
                        ))}
                    </Dropdown>
                </Row>
                <Row style={{flex: 'none', justifyContent: 'end', maxHeight: '36px'}}>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={exportCSV} color={theme.Magenta}  size={15}>Exportar a Excel</Text>
                </Row>
            </FilterBar>
            <Col style={{width: '100%', height: '100%', alignItems: 'start', justifyContent: 'start', position: 'relative', marginTop: 32}}>
                <ProcessTable table={table} theme={theme}/>

                {loading && table.getRowModel().rows.length === 0 &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Alfalfa}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
                {(isFetching) &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Alfalfa}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
            </Col>
        </Col>
    )
}

export default Proceso;